<template>
  <transition name="fade">
    <!-- Компонент перехвата нажатий -->
    <MovableWrapper
      @action="onAction"
      :isBlur="isBlur"
      :motionDisabled="motionDisabled"
      ref="movable-wrapper"
      v-if="show"
    >
      <div
        :class="['location', {
          'blur': isBlur
        }]"
      >
        <img
          src="/images/location/main.png"
          class="location__map"
        />
        <img
          src="/images/location/table.png"
          class="location__table"
        />
        <img
          src="/images/location/nosorog.png"
          class="location__nosorog"
        />
        <img
          src="/images/location/tables.png"
          class="location__tables"
          :style="{'opacity': setOpacityBalcony}"
        />
        <img
          src="/images/location/balcony.png"
          class="location__balcony-img"
          :style="{'opacity': setOpacityBalcony}"
        />
        <img
          src="/images/location/balcony-column-short.png"
          class="location__column-short"
          :style="{'opacity': setOpacityBalcony}"
        />
        <img
          src="/images/location/balcony-column-long.png"
          class="location__column-long"
          :style="{'opacity': setOpacityBalcony}"
        />
        <img
          src="/images/location/shadow.png"
          class="location__shadow-img"
          :style="{'opacity': setOpacityBalcony}"
        />
        <img
          src="/images/location/glasses.png"
          class="location__glasses-img"
        />

        <!-- Stands -->
        <div
          v-for="faculty in Faculties"
          :key="`stand-` + faculty.id"
          :class="['stand', `stand--${faculty.stand.direction}`, `stand--${faculty.id}`, {
            'active': getActiveStands(faculty.id)
          }]"
          :style="setPositions(faculty.stand.positions, faculty.id)"
          @click="actionStand(faculty)"
        >
          <p class="stand__name">{{ faculty.name }}</p>
        </div>

        <!-- NPC -->
        <div
          :class="['character character--npc',
            `character--npc--${npc.type}`,
            `${npc.direction}`, {
            'is-talking': is_talking && npc.id === 1,
            'active': isActiveNpc(npc.id),
            'action': getCurrentPoint === 5
          }]"
          v-for="npc in Characters"
          :key="npc.id"
          :style="setPositions(npc.positions)"
          @click="e => actionNpc(e, npc)"
        >
          <div class="character__wrapper">
            <div class="character__image-wrapper">
              <div class="character__image"></div>
            </div>
          </div>
        </div>

        <!-- Пользователь -->
        <div
          :class="['character character--user', `character--user--${getCharacter}`, {
            'dir--down': direction === DIRECTIONS.DOWN,
            'dir--up': direction === DIRECTIONS.UP,
            'dir--left': direction === DIRECTIONS.LEFT,
            'dir--right': direction === DIRECTIONS.RIGHT,
            'dir--up-right': direction === DIRECTIONS.UP_RIGHT,
            'dir--up-left': direction === DIRECTIONS.UP_LEFT,
            'dir--down-left': direction === DIRECTIONS.DOWN_LEFT,
            'dir--down-right': direction === DIRECTIONS.DOWN_RIGHT,
            'is-walking': is_walking
          }]"
          :style="{
            'top': `${user.pos_top}px`,
            'left': `${user.pos_left}px`,
            'z-index': getUserPositions.x > 25 && getUserPositions.y < 7 ? `${getUserPositions.y + 4}` : `${getUserPositions.y + 1}`
          }"
        >
          <div class="character__wrapper">
            <div class="character__image-wrapper">
              <div class="character__image" ref="character-image"></div>
            </div>
            <div class="character__level-wrapper">
              <div
                class="character__level-up"
                ref="level_up"
              />
            </div>
          </div>
        </div>

        <Dialog
          :show="showDialog"
          :currentPoint="getCurrentPoint"
          :style="dialogPositions"
          @continueQuest="continueQuest"
        />

        <!-- ... -->
        <p class="faculty-name faculty-name--bank">Факультет банковского дела</p>
        <p class="faculty-name faculty-name--legal">Юридический факультет</p>
        <p class="faculty-name faculty-name--sport">Факультет физической культуры</p>
        <p class="faculty-name faculty-name--design">Факультет дизайна</p>
      </div>

      <Interface
        :isBlur="isBlur"
        :visible="visibleInterface"
      />
      <transition name="fade">
        <div
          :class="['skip-all skip-all--default', {
            'blur': isBlur
          }]"
          v-if="visibleInterface && getCurrentPoint != 5"
        >
          <button
            type="button"
            class="btn skip-all__button click-sound"
            @click="!showDialog ? documents_popup = true : ''"
          >
            <i class="skip-all__icon"/>
            Подать документы
          </button>
        </div>
      </transition>
      <SelectFaculties
        v-model="faculties_popup"
        @continueQuest="continueQuest"
      />
      <SelectCharacter
        v-model="characters_popup"
      />
      <Instruction
        v-model="instruction_popup"
      />
      <Documents
        v-model="documents_popup"
        @continueQuest="continueQuest"
      />
      <Stand
        v-model="stand_popup"
        :stand="selectedStand"
        :currentPoint="getCurrentPoint"
        @continueQuest="continueQuest"
      />
      <start-instruction v-model="start_instruction"/>
    </MovableWrapper>
  </transition>
</template>

<script>
  import { mapGetters } from 'vuex'
  import MovableWrapper from '@/components/core/MovableWrapper'

  import Interface from '@/components/Interface'
  import Dialog from '@/components/Dialog'

  import { Characters, Faculties } from '@/data'

  import SelectFaculties from '@/components/popups/SelectFaculties'
  import SelectCharacter from '@/components/popups/SelectCharacter'
  import Instruction from '@/components/popups/Instruction'
  import StartInstruction from '@/components/popups/StartInstruction'
  import Documents from '@/components/popups/Documents'

  import Stand from '@/components/popups/Stand'

  const MATRIX = require("../../public/json/level_1_matrix.json")
  import { DIRECTIONS } from "@/constants"

  export default {
    props: {
      scale: {
        type: Number,
        default: 1
      }
    },
    components: {
      MovableWrapper,
      Dialog,
      Interface,
      SelectFaculties,
      SelectCharacter,
      Instruction,
      StartInstruction,
      Documents,
      Stand
    },
    data(){
      return {
        DIRECTIONS,
        faculties_popup: false,
        characters_popup: true,
        stand_popup: false,
        instruction_popup: false,
        start_instruction: false,
        documents_popup: false,
        isBlur: true,
        show: false,
        Characters,
        is_walking: false,
        is_talking: false,
        motionDisabled: true,
        direction: DIRECTIONS.UP,
        Faculties,
        activeStands: [],
        selectedStand: 1,
        allowableDistance: {
          y: 2,
          x: 2
        },
        visibleInterface: false,
        showDialog: false,
        dialogPositions: {
          bottom: '',
          right: ''
        },
        matrix: MATRIX,
        user: {
          pos_top: 0,
          pos_left: 0
        },
        walkingSpeed: 7
      }
    },
    created(){
      this.$store.commit('setUserPositions', {y: 14, x: 18});
      this.$store.commit('activateNpc', 1);

      const user = this.$store.getters.getUser;

      if(!user.registered){
        this.$router.push('screensaver');
        return;
      }

      this.user.pos_top = this.matrix[this.getUserPositions.y][this.getUserPositions.x].pos_top;
      this.user.pos_left = this.matrix[this.getUserPositions.y][this.getUserPositions.x].pos_left;

      setTimeout(() => this.show = true, 100);
    },
    mounted(){
      this.$root.$on('blur', (state) => this.isBlur = state);
      this.$root.$on('motionDisabled', (state) => this.motionDisabled = state);
    },
    watch: {
      getLevel(){
        this.$refs.level_up.classList.add('active');
        setTimeout(() => this.$refs.level_up.classList.remove('active'), 1000);
      },
      is_talking(value){
        if(value) setTimeout(() => this.is_talking = false, 2500);
      },
      characters_popup(value) {
        if(!value) {  // character was selected, just show the
          this.start_instruction = true;
        }
      }
    },
    computed: {
      ...mapGetters([
        'getUserPositions',
        'getActiveNpcIds',
        'getCurrentPoint',
        'getCurrentQuest',
        'getCharacter',
        'getLevel'
      ]),
      questCompleted(){
        return this.getCurrentPoint === 5;
      },
      setOpacityBalcony(){
        return this.getUserPositions.x > 24 ? 0.5 : 1;
      }
    },
    methods: {
      isActiveNpc(npcId) {
        return this.getActiveNpcIds && this.getActiveNpcIds.indexOf(npcId) >= 0;
      },
      onAction(action){
        switch(action){
          case 'up': {
            this.onNextCell(this.getUserPositions.y - 1, this.getUserPositions.x);
            this.direction = DIRECTIONS.UP;
            this.is_walking = true;
            break;
          }
          case 'right': {
            this.onNextCell(this.getUserPositions.y, this.getUserPositions.x + 1);
            this.direction = DIRECTIONS.RIGHT;
            this.is_walking = true;
            break;
          }
          case 'down': {
            this.onNextCell(this.getUserPositions.y + 1, this.getUserPositions.x);
            this.direction = DIRECTIONS.DOWN;
            this.is_walking = true;
            break;
          }
          case 'left': {
            this.onNextCell(this.getUserPositions.y, this.getUserPositions.x - 1);
            this.direction = DIRECTIONS.LEFT;
            this.is_walking = true;
            break;
          }
          case 'left-up': {
            this.onNextCell(this.getUserPositions.y - 1, this.getUserPositions.x - 1);
            this.direction = DIRECTIONS.UP_LEFT;
            this.is_walking = true;
            break;
          }
          case 'right-up': {
            this.onNextCell(this.getUserPositions.y - 1, this.getUserPositions.x + 1);
            this.direction = DIRECTIONS.UP_RIGHT;
            this.is_walking = true;
            break;
          }
          case 'down-right': {
            this.onNextCell(this.getUserPositions.y + 1, this.getUserPositions.x + 1);
            this.direction = DIRECTIONS.DOWN_RIGHT;
            this.is_walking = true;
            break;
          }
          case 'down-left': {
            this.onNextCell(this.getUserPositions.y + 1, this.getUserPositions.x - 1);
            this.direction = DIRECTIONS.DOWN_LEFT;
            this.is_walking = true;
            break;
          }
          case 'stop':
            this.is_walking = false;
        }
      },
      onNextCell(y, x){
        if(y < 0 || y >= this.matrix.length) return;
        if(x < 0 || x >= this.matrix[0].length) return;

        const nextCellType = this.matrix[y][x].type;

        if(nextCellType === 'road') {
          this.walkToNextCell(y, x);
        }
      },
      walkToNextCell(y, x){

        let this_pos = this.matrix[this.getUserPositions.y][this.getUserPositions.x]
        let next_pos = this.matrix[y][x]

        let between_y = this_pos.pos_top - next_pos.pos_top
        let between_x = this_pos.pos_left - next_pos.pos_left

        let step_y = Math.abs(between_y / 100)
        let step_x = Math.abs(between_x / 100)

        this.user.pos_top += between_y < 0 ? step_y * this.walkingSpeed : step_y * -this.walkingSpeed
        this.user.pos_left += between_x < 0 ? step_x * this.walkingSpeed : step_x * -this.walkingSpeed

        let {
          y: closest_y,
          x: closest_x,
        } = this.getClosestCell({...this.user})
        this.getUserPositions.y = closest_y;
        this.getUserPositions.x = closest_x;
      },
      getClosestCell(this_pos){
        let closest_tmp = {
          ...this_pos,
          y: 0,
          x: 0,
          distance: Number.MAX_VALUE,
        }

        for(let y = 0, y_length = this.matrix.length; y < y_length; y++){
          for(let x = 0, x_length = this.matrix[y].length; x < x_length; x++){
            let distance = Math.abs((this.matrix[y][x].pos_top - this_pos.pos_top)) + Math.abs((this.matrix[y][x].pos_left - this_pos.pos_left));
            if (distance < closest_tmp.distance) {
              closest_tmp.pos_top = this.matrix[y][x].pos_top;
              closest_tmp.pos_left = this.matrix[y][x].pos_left;
              closest_tmp.y = y;
              closest_tmp.x = x;
              closest_tmp.distance = distance;
            }
          }
        }

        return closest_tmp;
      },
      setPositions(element, ...args){
        return {
          left: this.matrix[element.y][element.x].pos_left + 'px',
          top: this.matrix[element.y][element.x].pos_top + 'px',
          zIndex: args[0] <= 5 || args[0] >= 13 ? element.y + element.x : element.y
        }
      },
      setDialogPositions(dialog) {
        this.dialogPositions.bottom = `${dialog.y}px`;
        this.dialogPositions.right = `${dialog.x}px`;
      },
      checkDistance(el){
        const {y: distanceY, x: distanceX} = this.allowableDistance;
        const {y: userY, x: userX} = this.getUserPositions;
        const {y: elY, x: elX} = el.positions;

        return userY <= elY + distanceY && userY >= elY - distanceY && userX <= elX + distanceX && userX >= elX - distanceX;
      },
      actionNpc(e, npc){
        if(!this.isActiveNpc(npc.id) && this.getCurrentPoint === 5 && this.checkDistance(npc) && !this.showDialog){
          if(npc.id > 1) {
            this.instruction_popup = true;
          } else {
            this.is_talking = true;
            this.showDialog = true;
          }

          this.$root.$emit('play-sound', 'click');
          this.motionDisabled = true;
          return;
        }
        else if(!this.isActiveNpc(npc.id) || !this.checkDistance(npc) || this.showDialog) return;

        this.$root.$emit('play-sound', 'click');

        this.$refs['movable-wrapper'].$emit('abort_actions');

        if(npc.id === 1) this.is_talking = true;

        this.motionDisabled = true;

        if(this.getCurrentPoint === 1 && !this.visibleInterface) this.visibleInterface = true;

        // rank up
        let currentQuest = this.getCurrentQuest;
        const score = currentQuest.addScore;

        if(score) {
          this.$store.dispatch('addScore', {
            score,
            questId: currentQuest.point
          });
        }

        this.setDialogPositions(npc.dialog);

        this.$refs['movable-wrapper'].$emit('abort_actions');

        switch(this.getCurrentPoint){
          case 2:
            this.$store.commit('setCurrentPoint', 3);
            this.$store.commit('deactivateNpc', 1);

            this.$store.commit('activateNpc', 2);
            this.$store.commit('activateNpc', 3);
            this.$store.commit('activateNpc', 4);
            break;
          case 3:
            this.$store.commit('setCurrentPoint', 4);
            break;
          case 5:
            if(this.isActiveNpc(npc.id)) this.$store.commit('deactivateNpc', npc.id);
            break;
        }

        this.showDialog = true;
      },
      actionStand(faculty){
        if(!this.questCompleted) {
          if(!this.checkDistance(faculty.stand) || this.showDialog) return;
        }

        this.$root.$emit('play-sound', 'click');

        this.$refs['movable-wrapper'].$emit('abort_actions');

        this.selectedStand = faculty.id;
        this.stand_popup = true;
        this.motionDisabled = true;
      },
      continueQuest(action, point, ...args){
        if(!action){
          this.showDialog = false;
          this.motionDisabled = false;
          return;
        }

        this.$refs['movable-wrapper'].$emit('abort_actions');

        switch(point){
          case 1:
            this.showDialog = false;
            this.faculties_popup = true;
            break;
          case 2:
            this.$store.commit('setCurrentPoint', 2);
            this.$store.commit('deactivateNpc', 1);

            this.faculties_popup = false;
            this.motionDisabled = true;
            this.showDialog = true;
            this.is_talking = true;

            this.activeStands = args[0];
            break;
          case 3: // activate next stand or return back to manager
            this.activeStands = this.activeStands.filter(faculty => faculty.id !== this.selectedStand);
            if(!this.activeStands.length) {
              this.$store.commit('activateNpc', 1);
            }
            break;
          case 4:  // open the operator dialogue
          case 5: // Documents
            this.$store.commit('setCurrentPoint', 5);
            this.$store.commit('deactivateNpc', 2);
            this.$store.commit('deactivateNpc', 3);
            this.$store.commit('deactivateNpc', 4);
            this.$store.commit('activateNpc', 1);

            this.$store.dispatch('addScore', {
              score: point === 4 ? 150 : 300,
              questId: this.getCurrentQuest
            });

            if(point === 4){
              this.showDialog = false;
              this.instruction_popup = true;
            } else {
                this.activeStands = [];
                this.documents_popup = false;
              }
        }
      },
      getActiveStands(faculty){
        return this.activeStands.find(el => el.id === faculty);
      },
      isActiveStand(stands){
        return stands.every(stand => !stand.active);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .location {
    position: relative;
    height: 100%;
    transition: filter 200ms;
    user-select: none;

    &.blur {
      filter: blur(10px);
      transition: filter 200ms;
    }
    &__map {
      position: absolute;
      top: 0;
      left: 0;
      pointer-events: none;
    }
    &__table {
      position: absolute;
      top: 372px;
      left: 1052px;
      pointer-events: none;
      z-index: 5;
    }
    &__nosorog {
      position: absolute;
      top: 519px;
      left: 1175px;
      pointer-events: none;
      z-index: 8;
    }
    &__tables {
      position: absolute;
      top: 420px;
      left: 1196px;
      pointer-events: none;
      transition: 300ms opacity 200ms;
      z-index: 15;
    }
    &__balcony-img {
      position: absolute;
      top: 63px;
      left: 986px;
      opacity: 1;
      transition: 300ms opacity 200ms;
      pointer-events: none;
      z-index: 14;
    }
    &__column-short {
      position: absolute;
      top: 705px;
      left: 1493px;
      opacity: 1;
      transition: 300ms opacity 200ms;
      pointer-events: none;
      z-index: 4;
    }
    &__column-long {
      position: absolute;
      top: 779px;
      left: 1267px;
      opacity: 1;
      transition: 300ms opacity 200ms;
      pointer-events: none;
      z-index: 12;
    }
    &__shadow-img {
      position: absolute;
      top: 579px;
      left: 1264px;
      opacity: 1;
      transition: 300ms opacity 200ms;
      pointer-events: none;
      z-index: 3;
    }
    &__glasses-img {
      position: absolute;
      top: 0;
      left: 0;
      opacity: .2;
      pointer-events: none;
      z-index: 999;
    }
  }
  .skip-all {
    transition: filter 200ms, opacity .5s;

    &--default {
      position: absolute;
      top: 25px;
      right: 25px;
      z-index: 999;
    }
    &.blur {
      filter: blur(10px);
    }
    &__button {
      min-width: auto;
      display: flex;
      padding: 15px 20px;
      align-items: center;
      font-size: 21px;
      color: #FFF;
    }
    &__icon {
      display: block;
      width: 34px;
      height: 30px;
      margin-right: 10px;
      background: url(/images/icons/documents.png) no-repeat;
      background-size: cover;
    }
  }
  .stand {
    position: absolute;
    cursor: pointer;
    user-select: none;
    background: url(/images/sprites/stands.png) no-repeat;
    background-size: auto 171px;
    transform: translate(-50%, -100%);

    &::before {
      position: absolute;
      content: '';
      display: none;
      top: -50px;
      left: -50px;
      background-image: url(/images/sprites/stands-active.png);
      background-repeat: no-repeat;
      background-size: auto 271px;
      pointer-events: none;
    }
    &::after {
      position: absolute;
      content: '';
      display: none;
      width: 45px;
      height: 45px;
      bottom: calc(100% + 20px);
      background: url(/images/logotip.png) no-repeat;
      background-size: cover;
      animation: pulse .5s cubic-bezier(0.21, 0.7, 0.43, 0.98) alternate infinite;
    }
    &.active::before {
      display: block;
    }
    &.active::after {
      display: block;
    }
    &--down-left {
      width: 107px;
      height: 146px;
      transform: translate(-70%, -89%);
    }
    &--down-left::before {
      width: 207px;
      height: 246px;
      background-position: -417px 0;
    }
    &--down-left.active::after {
      left: 6px;
    }
    &--up-left {
      width: 110px;
      height: 171px;
      transform: translate(-45%, -88%);
    }
    &--up-left::before {
      width: 210px;
      height: 271px;
      background-position: 0 0;
    }
    &--up-left.active::after {
      left: -2px;
    }
    &--up-right {
      width: 107px;
      height: 170px;
      transform: translate(-56%, -95%);
    }
    &--up-right::before {
      width: 207px;
      height: 270px;
      background-position: -210px 0;
    }
    &--up-right.active::after {
      left: 61px;
    }
    &--down-right {
      width: 109px;
      height: 144px;
      transform: translate(-25%, -91%);
    }
    &--down-right::before {
      width: 209px;
      height: 244px;
      background-position: -624px 0;
    }
    &--down-right::after {
      left: 57px;
    }
    &--2 {
      background-position: -108px 0;
    }
    &--3 {
      background-position: -216px 0;
    }
    &--4 {
      background-position: -324px 0;
    }
    &--5 {
      background-position: -432px 0;
    }
    &--6 {
      background-position: -540px 0;
    }
    &--7 {
      background-position: -651px 0;
    }
    &--8 {
      background-position: -762px 0;
    }
    &--9 {
      background-position: -870px 0;
    }
    &--10 {
      background-position: -978px 0;
    }
    &--11 {
      background-position: -1086px 0;
    }
    &--12 {
      background-position: -1194px 0;
      transform: translate(-58%, -97%);
    }
    &--13 {
      background-position: -1302px 0;
    }
    &--14 {
      background-position: -1412px 0;
    }
    &--15 {
      background-position: -1522px 0;
    }
    &--16 {
      background-position: -1632px 0;
    }
    &--17 {
      background-position: -1742px 0;
    }
    &--18 {
      background-position: -1852px 0;
    }
    &--19 {
      background-position: -1960px 0;
    }
    &--20 {
      background-position: -2068px 0;
    }
    &--21 {
      background-position: -2176px 0;
    }
    &__name {
      position: absolute;
      width: 210px;
      left: 50%;
      bottom: calc(100% + 20px);
      padding: 5px;
      opacity: 0;
      line-height: 1.3;
      text-align: center;
      font-size: 18px;
      color: #FFF;
      background: rgba(0, 7, 22, .5);
      transform: translateX(-50%);
      transition: opacity 200ms;
      pointer-events: none;
      z-index: 1;

      &::before {
        position: absolute;
        content: '';
        width: 0;
        height: 0;
        top: 100%;
        left: 50%;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid rgba(0, 7, 22, .5);
        transform: translateX(-50%);
      }
    }
    &:nth-of-type(5):hover &__name {
      display: none;
    }
    &:nth-of-type(5):hover ~ .faculty-name.faculty-name--bank {
      opacity: 1;
    }
    &:nth-of-type(7).active::after {
      display: none;
    }
    &:nth-of-type(7):hover &__name {
      display: none;
    }
    &:nth-of-type(7):hover ~ .faculty-name.faculty-name--legal {
      opacity: 1;
    }
    &:nth-of-type(8).active::after {
      display: none;
    }
    &:nth-of-type(8):hover &__name {
      display: none;
    }
    &:nth-of-type(8):hover ~ .faculty-name.faculty-name--sport {
      opacity: 1;
    }
    &:nth-of-type(12).active::after {
      display: none;
    }
    &:nth-of-type(12):hover &__name {
      display: none;
    }
    &:nth-of-type(12):hover ~ .faculty-name.faculty-name--design {
      opacity: 1;
    }
    &:hover &__name {
      opacity: 1;
    }
  }
  .faculty-name {
    position: absolute;
    width: 210px;
    padding: 5px;
    opacity: 0;
    line-height: 1.3;
    text-align: center;
    font-size: 18px;
    color: #FFF;
    background: rgba(0, 7, 22, .5);
    transition: opacity 200ms;
    pointer-events: none;

    &::before {
      position: absolute;
      content: '';
      top: 50%;
      left: auto;
      right: 100%;
      border-top: 10px solid transparent;
      border-right: 10px solid rgba(0, 7, 22, .5);
      border-bottom: 10px solid transparent;
      transform: translate(0, -50%);
    }
    &--bank {
      top: 225px;
      left: 204px;
      z-index: 20;
    }
    &--legal {
      top: 55px;
      left: 432px;
      z-index: 8;
    }
    &--sport {
      top: 34px;
      left: 670px;
      z-index: 5;
    }
    &--design {
      top: 630px;
      right: 7px;
      z-index: 42;
    }
  }
  .character {
    position: absolute;
    margin-top: 10px;
    text-align: center;
    transform: translate(-50%, -100%);
    pointer-events: none;
    user-select: none;

    &.active {
      cursor: pointer;
      pointer-events: auto;
    }
    &.active::before {
      content: '!';
      position: absolute;
      right: 27px;
      bottom: calc(100% + 20px);
      line-height: 1;
      text-shadow: 0 0px 10px #47bd93, 0 0px 10px #47bd93, 0 0px 10px #47bd93, 0 0px 10px #47bd93;
      font-size: 40px;
      font-weight: bold;
      color: #FFF;
      animation: pulse .5s cubic-bezier(0.21, 0.7, 0.43, 0.98) alternate infinite;
      pointer-events: none;
      z-index: 1;
    }
    &--user {
      pointer-events: none;
    }
    &--npc--manager {
      margin: 0;
      z-index: 8 !important;
    }
    &--npc--operator-1.active::before {
      right: 18px;
    }
    &--npc--operator-2.active::before {
      right: 16px;
    }
    &--npc--operator-3.active::before {
      right: 16px;
    }
    &.action {
      cursor: pointer;
      pointer-events: auto;
    }
    &__wrapper {
      width: 88px;
      height: 148px;
      pointer-events: none;
    }
    &__image-wrapper {
      position: relative;
      height: 100%;
      overflow: hidden;
      width: 100%;
    }
    &__image {
      position: relative;
      will-change: transform;
      width: 7920px;
      height: 740px;
      background-size: cover;
    }
    &__level-wrapper {
      position: absolute;
      width: 180px;
      height: 230px;
      bottom: -12px;
      left: -43px;
      overflow: hidden;
    }
    &__level-up {
      position: absolute;
      display: none;
      width: 1800px;
      height: 230px;
      bottom: 0;
      background: url(/images/sprites/level-up.png) no-repeat;
      background-size: cover;

      &.active {
        display: block;
        animation: level_up 1s steps(10);
        animation-fill-mode: forwards;
      }
    }

    // reverse direction
    &.dir--up-right &__image-wrapper,
    &.dir--up &__image-wrapper,
    &.dir--right &__image-wrapper {
      transform: scaleX(-1);
    }

    // stand 5s
    &.dir--down &__image,
    &.dir--right &__image,
    &.dir--down-left &__image,
    &.dir--up-right &__image,
    &.dir--up &__image,
    &.dir--up-left &__image,
    &.dir--left &__image,
    &.dir--up &__image ,
    &.dir--down-right &__image {
      animation: character_stand 5s steps(90) infinite;
      -moz-animation: character_stand 5s steps(90) infinite;
    }

    &.is-sitting &__image {
      animation: character_stand 8s steps(90) infinite !important;
      -moz-animation: character_stand 8s steps(90) infinite !important;
    }

    // background
    &.dir--up-left &__image {
      background-position-y: 0;
    }

    &.dir--left &__image,
    &.dir--up &__image {
      background-position-y: -148px;
    }

    &.dir--down-left &__image,
    &.dir--up-right &__image {
      background-position-y: -296px;
    }

    &.dir--down &__image,
    &.dir--right &__image {
      background-position-y: -444px;
    }

    &.dir--down-right &__image {
      background-position-y: -592px;
    }

    // npc images
    &--npc--manager &__image {
      background-image: url(/images/sprites/characters/manager_idle.png);
    }

    &--user--asian &__image {
      background-image: url(/images/sprites/characters/user_asian_idle.png);
    }
    &--user--black &__image {
      background-image: url(/images/sprites/characters/user_black_idle.png);
    }
    &--user--white &__image {
      background-image: url(/images/sprites/characters/user_white_idle.png);
    }
    &--user--woman &__image {
      background-image: url(/images/sprites/characters/user_woman_idle.png);
    }

    // Sitting 5s
    &.is-sitting &__image {
      width: 7920px !important;
      height: 132px !important;
    }

    &--npc--operator-1 {
      transform: translate(-27%, -117%);
    }
    &--npc--operator-1.is-sitting &__image {
      background-image: url(/images/sprites/characters/operator_1.png);
      animation-delay: 1s !important;
    }
    &--npc--operator-2 {
      transform: translate(-18%, -115%);
    }
    &--npc--operator-2.is-sitting &__image {
      background-image: url(/images/sprites/characters/operator_2.png);
    }
    &--npc--operator-3 {
      transform: translate(-36%, -121%);
    }
    &--npc--operator-3.is-sitting &__image {
      background-image: url(/images/sprites/characters/operator_3.png);
      animation-delay: 2s !important;
    }

    // Walking 1s
    &.is-walking &__image {
      animation: character_walk 1s steps(31) infinite !important;
    }

    &.is-walking &__image {
      width: 2728px !important;
      height: 740px !important;
    }

    &--user--asian.is-walking &__image {
      background-image: url(/images/sprites/characters/user_asian_walk.png);
    }
    &--user--black.is-walking &__image {
      background-image: url(/images/sprites/characters/user_black_walk.png);
    }
    &--user--white.is-walking &__image {
      background-image: url(/images/sprites/characters/user_white_walk.png);
    }
    &--user--woman.is-walking &__image {
      background-image: url(/images/sprites/characters/user_woman_walk.png);
    }

    // talking 2.5s
    &.is-talking &__image {
      animation: character_talk 2.5s steps(85) infinite !important;
    }

    &.is-talking &__image {
      width: 7480px !important;
      height: 740px !important;
    }

    &--npc--manager.is-talking &__image {
      background-image: url(/images/sprites/characters/manager_talk.png);
      animation-delay: 0s !important;
    }
  }
  @keyframes pulse {
    from {
      transform: translateY(10px);
    }
    to {
      transform: translateY(0);
    }
  }
</style>
